<small class="error" [class.hide]="hide">{{ errorMessage | translate }}</small>